import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, computed, effect, inject, input, output, Renderer2 } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SomethingWentWrongComponent } from 'mbs-ui-shared@components/something-went-wrong/something-went-wrong.component';

import { AlertContainerComponent } from 'mbs-ui-kit';

@UntilDestroy()
@Component({
  selector: 'page-layout',
  templateUrl: './page-layout.component.html',
  standalone: true,
  imports: [CommonModule, SomethingWentWrongComponent, AlertContainerComponent]
})
export class PageLayoutComponent {
  private document = inject<Document>(DOCUMENT);
  private renderer = inject(Renderer2);

  public pageClass = input<string>('');
  public contentClass = input<string>('');
  public showCustomErrorPage = input<boolean>(false);
  public showErrorPage = input<boolean>(false);
  public mode = input<'default' | 'flex'>('default');
  public hasTopOffset = input<boolean>(true);

  protected flexMode = computed(() => this.mode() === 'flex');

  public refresh = output<void>();

  constructor() {
    effect(() => this.renderer[this.flexMode() ? 'addClass' : 'removeClass'](this.document.body, 'overflow-y-hidden'));
  }
}
